module.exports = __webpack_public_path__ + "img/ic_ins_nor@2x.597f411.png";